export default __webpack_public_path__ + "static/silverfort-bb033f7191fc2da41ad29d0b21fc56fa.png";